import React, { Component } from 'react';
import './Cookies.scss';

class CookiesMessage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isCookieMessage: localStorage.getItem('isCookieMessage'),
    }
  }
  

  accept = () => {
    localStorage.setItem('isCookieMessage', 'true');
    this.setState({
      isCookieMessage: 'true',
    })
  }


  render() {
    let {formatMessage} = this.props;

    const {isCookieMessage} = this.state;

    if(isCookieMessage == 'true'){
      return null;
    }
    return (
      <div className="CookiesMessage">
        {formatMessage('msgCookieMessage')}
        <button onClick={this.accept} className="btn btn-primary" type="button"> {formatMessage('cookieBtnAcceptTitle')}</button>
        <span className="close" onClick={() => {this.setState({isCookieMessage: 'true'})}}/></div>
    );
  }
}

export default CookiesMessage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Footer/Cookies.js